import Link from 'next/link';
import { IComponentProps } from '@/interfaces/component.interface';
import { cn } from '@/lib/utils';

interface ComponentProps {
  text: any;
  component: 'header' | 'footer' | 'side';
  color: 'white' | 'black';
  lang?: string;
}




export default function NavLinks(props: ComponentProps) {
  const { text, component, color, lang, ...restProps } = props;

  const MenuLinks = [
    {
      name: 'Home',
      href: lang === 'it' ? '/it' : '/en',
    },
    {
      name: lang === 'it' ? 'Chi siamo' : 'About us',
      href: lang === 'it' ? '/it/chi-siamo' : '/en/about',
    },
    {
      name: lang === 'it' ? 'Il Progetto' : 'The Project',
      href: lang === 'it' ? '/it/progetto' : '/en/project',
    },
    {
      name: lang === 'it' ? 'Contatti' : 'Contacts',
      href: lang === 'it' ? '/it/contattaci' : '/en/contacts',
    },
  ];



  return (
    <nav className={`${component === 'header' && 'block'} sm:hidden z-10`}>
      <ul
        className={`${component === 'footer' && ' flex flex-col gap-2'} ${
          component === 'side' && ' flex flex-col mt-12'
        } ${component === 'header' && ' flex'}`}
      >
        {MenuLinks.map((item, index) => (
          <li
            key={index}
            className={cn(
              'flex items-center px-[30px] text-xl border-white leading-6 font-normal tracking-normal',
              { 'border-r-[0.75px]': index < MenuLinks.length - 1 },
              { 'border-[#101011]': color === 'black' }
            )}
          >
            <Link href={item.href} {...restProps}>
              {item.name}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}